import { ActionButton, Buttons, CancelButton, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import { accountingProviders } from '~/lookups';
import React from 'react';

export default function ReloadInvoiceFromAccountingDialog({ invoice, accountingProvider, resolve }) {
  const { workspace } = useWorkspace();
  const [{ isSubmitting, saved }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const accountingProviderName = accountingProviders[accountingProvider].name;
  const connectionName = invoice.accountingConnectionName || accountingProviderName;

  const handleSubmit = async () => {
    form.submit();

    try {
      const { data } = await api.www
        .workspaces(workspace.id)
        .invoices(invoice.id)
        [`loadFrom${accountingProviderName}`]();

      switch (data?.status) {
        case 'voided':
          await resolve();
          toast.warning(
            `This invoice was voided in ${accountingProviderName}. The Ruddr invoice is now unlinked from ${accountingProviderName}.`,
          );
          break;

        default:
          await resolve(data);
          toast.success(`Invoice #${data.invoice.number} has been reloaded from ${accountingProviderName}.`);
          break;
      }
    } catch (error) {
      toast.error(
        error.message ?? `An error has occurred. The invoice has not been reloaded from ${accountingProviderName}.`,
      );
      form.done();
    }
  };

  return (
    <ModalCard title={`Reload from ${accountingProviderName}`} onClose={() => resolve(false)}>
      <ModalCard.Body>{`Are you sure you want to reload this invoice from ${connectionName}?`}</ModalCard.Body>

      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={() => resolve(false)}>Cancel</CancelButton>
          <ActionButton isLoading={isSubmitting} ok={saved} onClick={handleSubmit}>
            Load
          </ActionButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
